import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10230a21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between gap-2" }
const _hoisted_2 = { class: "p-input-icon-left float-right" }
const _hoisted_3 = ["src", "onError"]

import { Patient } from '@/interfaces/Patient';
import { ref, PropType, toRaw, watch } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Tag from 'primevue/tag';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientList',
  props: {
  patients: {
    type: Array as PropType<Patient[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;

const filteredPatients = ref<Patient[]>([...props.patients]);

const searchQuery = ref();

const safeDisplay = (value: string): string => value || '';

const clearFilter = () => {
  searchQuery.value = '';
  filteredPatients.value = [...props.patients];
};

const searchData = () => {
  const query = searchQuery.value?.toLowerCase() || '';
  filteredPatients.value = props.patients.filter((wrapperPatient) => {
    const patient = toRaw(wrapperPatient);
    return (
      patient.phoneNo?.toLowerCase().includes(query) ||
      patient.firstName?.toLowerCase().includes(query) ||
      patient.lastName?.toLowerCase().includes(query) ||
      patient.email?.toLowerCase().includes(query) ||
      patient.diagnose?.toLowerCase().includes(query)
    );
  });
};

const setDefaultProfileImage = (patient: Patient) => {
  patient.photoUrl =
    'https://www.vhv.rs/dpng/d/256-2569650_men-profile-icon-png-image-free-download-searchpng.png';
};

const onSelectedRow = (event: any) => {
  return;
};

watch(
  () => props.patients,
  (newValue) => {
    filteredPatients.value = [...newValue];
    searchData();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    value: filteredPatients.value,
    onRowSelect: onSelectedRow,
    selectionMode: "single",
    stripedRows: "",
    paginator: "",
    rows: 5,
    rowsPerPageOptions: [5, 10, 20, 50]
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          type: "button",
          class: "p-button-sm",
          icon: "pi pi-filter-slash",
          outlined: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (clearFilter()))
        }),
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_IconField, null, {
            default: _withCtx(() => [
              _createVNode(_component_InputIcon, { class: "pi pi-search" }),
              _createVNode(_unref(InputText), {
                class: "md:w-auto w-10rem",
                onInput: searchData,
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                placeholder: "Caută.."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), { header: "" }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("img", {
            width: "30",
            height: "30",
            src: data.photoUrl ? data.photoUrl : setDefaultProfileImage(data),
            alt: "",
            onError: ($event: any) => (setDefaultProfileImage(data))
          }, null, 40, _hoisted_3)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "Nume" }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(safeDisplay(data.firstName) + ' ' + safeDisplay(data.lastName)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "phoneNo",
        header: "Telefon"
      }),
      _createVNode(_unref(Column), { header: "Email" }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.email ? data.email : '-'), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "diagnose",
        header: "Diagnostic"
      }),
      _createVNode(_unref(Column), { header: "Confirmat" }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, [
            _createVNode(_unref(Tag), {
              severity: data.confirmed === true ? 'success' : 'danger',
              value: data.confirmed === true ? 'confirmat' : 'neconfirmat'
            }, null, 8, ["severity", "value"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), { header: "Status" }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", null, [
            _createVNode(_unref(Tag), {
              severity: data.status == null ? 'success' : 'danger',
              value: data.status == null ? 'activ' : 'inactiv'
            }, null, 8, ["severity", "value"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})